import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { AsamcoAuthService, AsamcoUserService } from '@asamco/base';
import { bind, pathJoin, showErrorSwal, skipAuthInterceptor } from '@asamco/utils';
import DevExpress from 'devextreme';
import { DxDataGridComponent, DxSelectBoxModule, DxDataGridModule } from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import notify from 'devextreme/ui/notify';
import { BehaviorSubject, from, Observable, Subject } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { UserManagementPermissions } from '../../enums/user-management-permissions.enum';
import { Company } from '../../interfaces/company.interface';
import { SelectedCompanyService } from '../../selected-company/selected-company.service';
import { UsermanagementService } from '../../services/usermanagement.service';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DxoExportModule, DxoFilterRowModule, DxoEditingModule, DxoSelectionModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
import { NgIf, NgSwitch, NgSwitchCase, AsyncPipe } from '@angular/common';
import { UserCompanyService } from '../../services/user-company.service';

@Component({
    selector: 'app-shell-user-permissions-management-admin',
    templateUrl: './user-permissions-management-admin.component.html',
    styleUrls: ['./user-permissions-management-admin.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, DxSelectBoxModule, DxDataGridModule, DxoExportModule, DxoFilterRowModule, DxoEditingModule, DxoSelectionModule, DxiColumnModule, DxTemplateModule, NgSwitch, NgSwitchCase, AsyncPipe]
})
export class UserPermissionsManagementAdminComponent implements OnInit {

	@ViewChild("usercompanygrid") dataGrid: DxDataGridComponent;

	public canAssignUserManagementPermissions$: Observable<boolean> = new Observable<boolean>();
  public companyList: Observable<Company[]> = new Observable<Company[]>();
  public adminDataSource$: Subject<DevExpress.data.DataSource> = new BehaviorSubject<DevExpress.data.DataSource>(undefined);
  public destroy$: Subject<void> = new Subject<void>();
	public selectedCompanyId: number;


  constructor(private asamcoUserService: AsamcoUserService, private selectedCompanyService: SelectedCompanyService, private auth: AsamcoAuthService, private http: HttpClient, private userManagementService: UsermanagementService, private userCompanyService: UserCompanyService) {
		this.canAssignUserManagementPermissions$ = from(this.asamcoUserService.hasAssignedPermission('AL3_USERMANAGEMENT_ASSIGN'));
		this.canAssignUserManagementPermissions$.subscribe(canAssignUserManagementPermissions => { if (canAssignUserManagementPermissions) { this.setupAdminDataSource(undefined); this.getCompanies() } })
  }

  ngOnInit(): void {

  }

  selectCompany(e) {
		this.setupAdminDataSource(e.value)
	}

  getCompanies() {
		//NOTE: Only works for superadmins, don't bother else
		this.companyList = this.selectedCompanyService.getCompanies().pipe((map(item => { return item.sort((one, two) => (one.name < two.name ? -1 : 1)) })));
	}


	setupAdminDataSource(companyId: number) {
		if(!companyId) return;
		this.selectedCompanyId = companyId;

		this.selectedCompanyService
			.getCompanies()
			.pipe(
				switchMap((item: any) => {
					return from(this.userCompanyService.GetUserControlOverview(companyId))
				}), takeUntil(this.destroy$)
			)
			.subscribe((e: any) => {
				//Retrieve the lowest creationDate and assign that user as the owner
				let adminDataSource = new DataSource({
					store: {
						type: 'array',
						key: 'id',
						data: e,
					},
				});
				this.adminDataSource$.next(adminDataSource)
			});
	}

	@bind
	setCellValueDelete(newData, value, currentRowData) {
		this.dataGrid.disabled = true;
		newData.canDeleteLinks = value;
		this.userManagementService.updateUserEntity(this.selectedCompanyId, currentRowData.id, value, UserManagementPermissions.deletelink).subscribe(e => {
			this.dataGrid.disabled = false;
			notify({
				message: 'Successfully saved settings',
				type: 'success',
				displayTime: 1000,
			});
		}, error => {
			this.dataGrid.disabled = false;
			showErrorSwal(error)
		});
	}

	@bind
	setCellValueEdit(newData, value, currentRowData) {
		this.dataGrid.disabled = true;
		newData.canEditLinks = value;
		this.userManagementService.updateUserEntity(this.selectedCompanyId, currentRowData.id, value, UserManagementPermissions.editlink).subscribe(e => {
			this.dataGrid.disabled = false;
			notify({
				message: 'Successfully saved settings',
				type: 'success',
				displayTime: 1000,
			});
		}, error => {
			this.dataGrid.disabled = false;
			showErrorSwal(error)
		});
	}

	@bind
	setCellValueRun(newData, value, currentRowData) {
		this.dataGrid.disabled = true;
		newData.canRunLinks = value;
		this.userManagementService.updateUserEntity(this.selectedCompanyId, currentRowData.id, value, UserManagementPermissions.runlink).subscribe(e => {
			this.dataGrid.disabled = false;
			notify({
				message: 'Successfully saved settings',
				type: 'success',
				displayTime: 1000,
			});
		}, error => {
			this.dataGrid.disabled = false;
			showErrorSwal(error)
		});
	}

	@bind
	setCellValueEnableOrDisable(newData, value, currentRowData) {
		this.dataGrid.disabled = true;
		newData.canEnableOrDisableLinks = value;
		this.userManagementService.updateUserEntity(this.selectedCompanyId, currentRowData.id, value, UserManagementPermissions.enableordisablelink).subscribe(e => {
			this.dataGrid.disabled = false;
			notify({
				message: 'Successfully saved settings',
				type: 'success',
				displayTime: 1000,
			});
		}, error => {
			this.dataGrid.disabled = false;
			showErrorSwal(error)
		});
	}

	@bind
	setCellValueCreate(newData, value, currentRowData) {
		this.dataGrid.disabled = true;
		newData.canCreateLinks = value;
		this.userManagementService.updateUserEntity(this.selectedCompanyId, currentRowData.id, value, UserManagementPermissions.createlink).subscribe(e => {
			this.dataGrid.disabled = false;
			notify({
				message: 'Successfully saved settings',
				type: 'success',
				displayTime: 1000,
			});
		}, error => {
			this.dataGrid.disabled = false;
			showErrorSwal(error)
		});
	}

	@bind
	setCellValueCspfsMockDataAccess(newData, value, currentRowData) {
		this.dataGrid.disabled = true;
		newData.cspfsMockDataAccess = value;
		this.userManagementService.updateUserEntity(this.selectedCompanyId, currentRowData.id, value, UserManagementPermissions.cspfsaccessmockdata).subscribe(e => {
			this.dataGrid.disabled = false;
			notify({
				message: 'Successfully saved settings',
				type: 'success',
				displayTime: 1000,
			});
		}, error => {
			this.dataGrid.disabled = false;
			showErrorSwal(error)
		});
	}

	@bind
	setCellValueCanViewApplicationLogs(newData, value, currentRowData) {
		this.dataGrid.disabled = true;
		newData.canViewApplicationLogs = value;
		this.userManagementService.updateUserEntity(this.selectedCompanyId, currentRowData.id, value, UserManagementPermissions.canviewapplicationlogs).subscribe(e => {
			this.dataGrid.disabled = false;
			notify({
				message: 'Successfully saved settings',
				type: 'success',
				displayTime: 1000,
			});
		}, error => {
			this.dataGrid.disabled = false;
			showErrorSwal(error)
		});
	}

	@bind
	setCellValueCspMockDataAccess(newData, value, currentRowData) {
		this.dataGrid.disabled = true;
		newData.cspMockDataAccess = value;
		this.userManagementService.updateUserEntity(this.selectedCompanyId, currentRowData.id, value, UserManagementPermissions.cspaccessmockdata).subscribe(e => {
			this.dataGrid.disabled = false;
			notify({
				message: 'Successfully saved settings',
				type: 'success',
				displayTime: 1000,
			});
		}, error => {
			this.dataGrid.disabled = false;
			showErrorSwal(error)
		});
	}

  ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

}
